module.exports = __webpack_public_path__ + "img/6abc7f2b-3112-495a-ae73-c908f0b5a544.8e6e9572.webp";